import { gql } from '@apollo/client'

import { MutationService, getMutationService } from '../../../../helpers/GraphqlHelpers'
import { UserFragment } from '../../../fragments'
import { ResetPasswordMutation } from '../../../generated/graphql'

export const resetPassword: MutationService = getMutationService({
  mutation: gql`
    mutation resetPassword($token: String!, $email: String!, $password: String!) {
      resetPassword(token: $token, email: $email, password: $password) {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  transformer: (response: ResetPasswordMutation) => {
    return response.resetPassword
  },
})
